export const getElapsedTime = (startTime: React.MutableRefObject<number | null>) => {
	const endTime = Date.now();
	let elapsedTimeInSeconds = 0;
	if (startTime.current !== null) {
		elapsedTimeInSeconds = (endTime - startTime.current) / 1000; // Convert to seconds
	}
	return elapsedTimeInSeconds;
};
